export default "__VITE_ASSET__C3O9$maR__"